<template>
  <div v-if="items.length" class="plot-line-legend-bar">
    <span
      v-for="item in items"
      :key="item.id"
      class="plot-line-legend-bar__item"
      :class="{ 'plot-line-legend-bar__item--hidden': isHidden(item.id) }"
      @click="toggle(item.id)"
    >
      <svg class="plot-line-legend-bar__symbol" width="16" height="12" aria-hidden="true">
        <path d="M0 6 L16 6" :stroke="isHidden(item.id) ? '#cccccc' : item.color" stroke-width="2" stroke-dasharray="5,3" />
      </svg>
      <span class="plot-line-legend-bar__label">{{ item.legendName }}</span>
    </span>
  </div>
</template>

<script>
// Highcharts 9 draws only one legend. The line names keep the built in legend
// at the top of the chart. This bar copies that legend look for the plot lines
// and sits under the chart. A click hides or shows a plot line.
export default {
  name: "plot-line-legend-bar",
  props: {
    plotLines: Array,
    hidden: Array
  },
  computed: {
    items() {
      return (this.plotLines || []).filter(plotLine => plotLine.id && plotLine.legendName);
    }
  },
  methods: {
    isHidden(id) {
      return (this.hidden || []).indexOf(id) !== -1;
    },
    toggle(id) {
      const next = this.isHidden(id) ? (this.hidden || []).filter(value => value !== id) : (this.hidden || []).concat(id);
      this.$emit("update:hidden", next);
    }
  }
};
</script>

<style scoped>
.plot-line-legend-bar {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin: 8px 0;
}
.plot-line-legend-bar__item {
  display: inline-flex;
  align-items: center;
  margin: 0 10px;
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  color: #333333;
}
.plot-line-legend-bar__item:hover {
  color: #000000;
}
.plot-line-legend-bar__item--hidden,
.plot-line-legend-bar__item--hidden:hover {
  color: #cccccc;
}
.plot-line-legend-bar__symbol {
  margin-right: 5px;
}
.plot-line-legend-bar__label {
  line-height: 1;
}
</style>
